import ChildTemplate from '../_/ChildTemplate';

export default class extends ChildTemplate {
  show = false;
  title = '';
  message = '';
  close = '';
  accept = '';
  #resolve = () => {
  };
  #reject = () => {
  };

  open(data = {}) {
    this.show = true;
    this.title = data.title || 'Подтвердите';
    this.message = data.message || '';
    this.close = data.close || 'Отмена';
    this.accept = data.accept || 'Подтвердить';

    return new Promise((resolve, reject) => {
      this.#resolve = resolve;
      this.#reject = reject;
    });
  }

  resolve() {
    if (this.#resolve) {
      this.#resolve();
    }
    this.finally();
  }

  reject() {
    if (this.#reject) {
      this.#reject();
    }
    this.finally();
  }

  finally() {
    this.show = false;
    this.title = '';
    this.message = '';
    this.close = '';
    this.accept = '';
  }
}
